var _mask, _rect, _mask2, _rect2, _mask3, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7379_1047",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552,
    fill: "white",
    stroke: "#0F5BF1",
    strokeWidth: 2.28221,
    mask: "url(#path-1-inside-1_7379_1047)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_7379_1047",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.69873,
    y: 6.63672,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.69873,
    y: 6.63672,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552,
    fill: "white",
    stroke: "#0F5BF1",
    strokeWidth: 2.28221,
    mask: "url(#path-2-inside-2_7379_1047)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_7379_1047",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.426,
    y: 15.6992,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552,
    transform: "rotate(-173.376 11.426 15.6992)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.426,
    y: 15.6992,
    width: 11.2768,
    height: 14.096,
    rx: 0.570552,
    transform: "rotate(-173.376 11.426 15.6992)",
    fill: "white",
    stroke: "#0F5BF1",
    strokeWidth: 2.28221,
    mask: "url(#path-3-inside-3_7379_1047)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/CopyButton.bf2fe5e1e1ff9890856b2730f0b9ef3d.svg";
export { ForwardRef as ReactComponent };